module.exports = __webpack_public_path__ + "media/images/application/template/logos/placeholder-logo-tall-83b4025a5ad05d39c556ab5b7e25a6b2.png";